// Bloom, the look of loading inside the frame (02-building-blocks.md, Bloom, points 2, 4, 5 and 6): the
// circle's ID colour on the page for the placeholders' tint and sheen. Since v1.58.48 the brand moment and
// the switch's colour layer are gone: the start screen (03) is the start's and the switch's brand moment.
import { idColour } from '../core/format';
import { serverOf } from '../core/session';

/** The circle's ID colour on the page, for Bloom's tints: the placeholders and the side list's header (07). */
export const paintCircle = (userId: string | undefined) => void (userId && document.documentElement.style.setProperty('--circle', `var(--name-${idColour(serverOf(userId))})`));
